import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/ats?${p}`);
  },
  list(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/ats/list?${p}`);
  },
  showById(id) {
    return api.get(`/api/v1/ats/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/ats`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/ats/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/ats/${id}`);
  },
  restoreAts(id) {
    return api.post(`/api/v1/ats/restore/${id}`);
  },
  updateClient(ats_id, data) {
    return api.put(`/api/v1/ats/update-client/${ats_id}`, data);
  },
};
